export const emailRegex = /^\S+@\S+\.\S+$/;

export const rules = {
  required: (label = 'This field') => ({
    required: `${label} is required`,
  }),
  email: {
    required: 'Email is required',
    pattern: { value: emailRegex, message: 'Enter a valid email' },
  },
  password: {
    required: 'Password is required',
    minLength: { value: 8, message: 'Password must be at least 8 characters' },
  },
};
